// Constant Data for Seller

export const SELLER_TYPE = {
  EXCLUSIVE: 'exclusive'
}

export const GENDER = {
  FEMALE : 'female',
  MALE   : 'male'
}

export const REFERRER = {
  POI        : 'profession_organiser_indonesia',
  TINKERLUST : 'tinkerlust',
  GOOGLE     : 'google',
  FACEBOOK   : 'facebook',
  INSTAGRAM  : 'instagram',
  TIKTOK     : 'tiktok',
  FRIEND     : 'friend',
  OTHERS     : 'others'
}
